import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useState } from "react";
import logEvent from "lib/ga/miscEvent";
import styles from './contactForm.module.css'
import { openModalAction } from "_slices/modal";
interface RootState {
  user: {
    forename: string,
    surname: string,
    email: string,
    company: {
      name: string
    },
    telephone: string
  };
}
const ContactForm = () => {
  const reduxDispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  let [errorMessage, setErrorMessage] = useState<string | string[]>('');
  let [formSent, setFormSent] = useState(false);

  let [name, setName] = useState<string>(user && user.forename ? user.forename + " " + user.surname : "");
  let [email, setEmail] = useState<string>(user ? user.email : "");
  let [phone, setPhone] = useState<string>(user ? user.telephone : "");
  let [company, setCompany] = useState<string>(user && user?.company?.name ? user.company.name : '');
  let [message, setMessage] = useState<string>('');
  let [reason, setReason] = useState<string>('');
  let reasons = ["I’d like to list my properties",
    "I’d like to sponsor my schemes",
    "I’d like to advertise my brand",
    "I’d like to find out more about Completely Retail",
    "I have a technical problem",
    "I need help contacting an agent",
  ];

  const validationChecksMeth = (data) => {
    let errors: string[] = [];
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let textErrors = {
      name: "name",
      email: "email",
      phone: "phone",
      company: "company",
      message: "message",
      reason: "reason for contacting"
    }

    Object.keys(data).forEach((item) => {
      if (data[item] === '') {
        errors.push(`You have entered a invalid ${textErrors[item]}`)
      } else if (data[item].length < 2) {
        errors.push(`You have entered a invalid ${textErrors[item]}`)
      } else if (item === 'email' && !data[item].match(mailformat)) {
        errors.push('You have entered a invalid email address')
      } else if (item === 'phone' && data[item].length < 7) {
        errors.push("You have entered a invalid phone number")
      }
    })

    if (errors.length > 0) {
      setErrorMessage(errors)

      return false
    }
    return true;
  }

  async function formSubmit(e) {
    e.preventDefault();
    setFormSent(true);
    setErrorMessage('');

    if (!validationChecksMeth({
      name,
      email,
      phone,
      company,
      message,
      reason
    })) {
      setFormSent(false);
      return 'bad'
    }

     try {
       const { data, status } = await axios.post(
         `${process.env.NEXT_PUBLIC_APP_URL}/api/mail/contactUs`,
         {
           name,
           email,
           phone,
           company,
           message,
           reason,
           agent: 128599,
           url: window.location.href,
         },
         {
           headers: {
             accept: "application/json",
             "content-type": "application/json",
           },
         }
       );
 
       if (Math.floor(status / 100) === 2) {
         logEvent({
           category: "Contact us",
           action: "Contact us form submit",
           label: reason,
         });
 
         setMessage('');
         setReason('');
 
         reduxDispatch(
           openModalAction({
             componentName: "GeneralSuccessMessage",
             componentProps: {
               title: "Thank you for getting in touch!",
               subHeading: 'We appreciate you contacting us. One of our colleagues will get back in touch soon.',
               success: true
             },
           })
         );
         setFormSent(false);
         return data;
       } else {
         setErrorMessage("We couldn't send your message right now. Please try again in a minute.");
         setFormSent(false);
         return "BAD";
       }
     } catch (error) {
       setErrorMessage("We couldn't send your message right now. Please try again in a minute.");
       setFormSent(false);
       return "BAD";
     }
  };


  return (
    <div className={styles.ContactFormWrapper}>
      <h2>Get in touch</h2>
      <form onSubmit={(e) => formSubmit(e)}>
        <div className={styles.formGroup}>
          <input type="text" required id="fname" name="fname" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
          <input type="text" required id="email" name="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className={styles.formGroup}>
          <input type="text" id="Phone" required name="Phone" placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
          <input type="text" id="Company" name="Company" placeholder="Company" value={company} onChange={(e) => setCompany(e.target.value)} />
        </div>

        <select id="reason" required name="reason" value={reason} onChange={(e) => setReason(e.target.value)}>
          <option value="" className="defaultSelect">Reason for contacting</option>
          {reasons.map((reason, i) => {
            return <option key={i} value={reason} >{reason}</option>
          })}
        </select>

        <textarea rows={4} cols={50} placeholder="Message" required value={message} onChange={(e) => setMessage(e.target.value)} />

        {errorMessage && (
          <div className={styles.alertDanger}>
            {Array.isArray(errorMessage) && (
                <ul>
                  {errorMessage.map((message, index) => {
                    return <li key={index}>{message}</li>;
                  })}
                </ul>
            )}

            {
              !Array.isArray(errorMessage) && (
                <>{errorMessage}</>
              )
            }
          </div>
        )}

        <button type="submit" disabled={formSent}>Submit</button>
      </form>
    </div>

  );
};

export default ContactForm;
